import { Vector3 } from "three";

export function getPositionFromCoordinates(lat: number, lon: number, radius: number): Vector3 {
  const phi = (90 - lat) * (Math.PI / 180);
  const theta = (lon + 180) * (Math.PI / 180);
  const x = -(radius * Math.sin(phi) * Math.cos(theta));
  const z = radius * Math.sin(phi) * Math.sin(theta);
  const y = radius * Math.cos(phi);
  return new Vector3(x, y, z);
}

/**
 * By default meshes in Three.js have origin in their center, but we want our marker to have origin
 * in the middle of its bottom side. Therefore we have to fix its position, by adding some latitude.
 * A particularly fastidious reader can ask for a proof of the following formulae.
 *
 * @param height marker height
 * @param radius earth radius
 * @returns the angle in degrees to be added to the marker's latitude
 */
export function getMarkerTransformOriginAngle(height: number, radius: number): number {
  const aRad = Math.atan(height / (2 * radius));
  const aDeg = (aRad * 180) / Math.PI;
  return aDeg;
}
